import { WebBridgeApi } from 'ijsbridge'

// app退后
export const useAppGoBack = () => {
  WebBridgeApi.router({
    route: 'back',
  })
}
